import type { State as StateType } from '@ps/web-core-intl';
import React from 'react';

import type { OnClickProp } from '@swf/core/types/Props';

import ListItem from '../../../ListItem/ListItem';

type Props = OnClickProp & StateType;

const State: React.FunctionComponent<Props> = ({ text, ...props }) => (
  <ListItem primary={text} {...props} textOnly />
);

export default State;
